





































import { Component, Vue, Prop } from 'vue-property-decorator';
import jQuery from 'jquery';
import Modal from './Base.vue';

@Component({
	name: 'CallLogModal',
	components: {
		Modal,
	},
})
export default class CallLogModal extends Vue {
	@Prop() public selectedCall: any;
	private secs = 32;
	private playAudio() {
		const p = jQuery(`#audio`);
		p.currentTime = this.secs;
		console.log('Playing at secs: ' + this.secs);
		p.play();
	}
	private created() {
		console.log('selectedCall', this.selectedCall);
	}
}
